import { useCallback } from 'react';

import { useNavigation } from '@react-navigation/native';

import { useModals } from '@/feature/alerts/hooks/use-modals';
import { Product, useJurisdictionStore } from '@/hooks/use-jurisdiction';

export const useOpenTermsLink = (onWebViewOpened?: () => void) => {
    const { navigate } = useNavigation();
    const { dismissAll } = useModals();

    const jurisdictionSettings = useJurisdictionStore(state => state.jurisdictionSettings);
    const activeProduct = useJurisdictionStore(state => state.product);

    const getFallbackTermsUrl = (product: Product): string => {
        switch (product) {
            case Product.Arcade:
                return 'https://help.betr.app/en/articles/11750321-betr-arcade-terms-and-conditions';
            case Product.Pickem:
                return 'https://help.betr.app/en/articles/9462096-betr-picks-terms-and-conditions';
            case Product.None:
            default:
                return 'https://help.betr.app/en/collections/9579264-terms-and-conditions';
        }
    };

    const FALLBACK_TERMS_URL = getFallbackTermsUrl(activeProduct);

    const termsAndConditionsUrl =
        jurisdictionSettings?.productConfig?.screenLinks?.find(link => link.link_type === 'TermsAndConditions')?.url ||
        FALLBACK_TERMS_URL;

    return useCallback(() => {
        if (termsAndConditionsUrl) {
            dismissAll();
            onWebViewOpened?.();
            navigate('ModalWebView', { uri: termsAndConditionsUrl });
        }
    }, [dismissAll, navigate, onWebViewOpened, termsAndConditionsUrl]);
};
